import Spinner from '@/components/atom/spinner';
import { LoaderContainer } from '@/components/molecules/loader/styles';

const Loader = (props: { size?: number; color?: string }) => {
  return (
    <LoaderContainer>
      <Spinner size={props.size} color={props.color} />
    </LoaderContainer>
  );
};
export default Loader;
